export enum HttpContentType {
    CSV = "text/csv",
    FORM_DATA = "multipart/form-data",
    JSON = "application/json",
    OCTET_STREAM = "application/octet-stream",
}
